import type { GetOrganizationsInOwnGeoAreaSelectionTagsEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

// TODO: wire real pagination in the UI and drop the count=1000 workaround.
const MAXIMUM_PAGE_COUNT_FALLBACK = 1000;

type UseGetOrganizationsInOwnGeoAreaSelectionOptions = {
  tags?: GetOrganizationsInOwnGeoAreaSelectionTagsEnum[];
  page?: number;
  count?: number;
  enabled?: boolean;
};

export const useGetOrganizationsInOwnGeoAreaSelection = ({
  tags = [],
  page,
  count,
  enabled = true
}: UseGetOrganizationsInOwnGeoAreaSelectionOptions = {}) => {
  const { isAuthenticated } = useAuth();

  const effectiveCount = count ?? MAXIMUM_PAGE_COUNT_FALLBACK;

  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [
      API_CACHE_KEYS.ORGANIZATIONS_IN_OWN_GEO_AREA_SELECTION,
      tags,
      page,
      effectiveCount
    ],
    queryFn: async () => {
      const response = await api.getOrganizationsInOwnGeoAreaSelection({
        tags: tags.length > 0 ? new Set(tags) : undefined,
        page,
        count: effectiveCount
      });
      return response.content ?? [];
    },
    enabled: isAuthenticated && enabled
  });
};
